<template>
  <div class="user-add-container">
    <div class="page-header">
      <h3>添加用户</h3>
    </div>
    
    <div class="content-wrapper">
      <el-card>
        <div slot="header" class="clearfix">
          <span>用户信息表单</span>
        </div>
        
        <el-form ref="userForm" :model="userForm" :rules="rules" label-width="100px">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="userForm.username" placeholder="请输入用户名" />
          </el-form-item>
          
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="userForm.password" placeholder="请输入密码" />
          </el-form-item>
          
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input type="password" v-model="userForm.confirmPassword" placeholder="请再次输入密码" />
          </el-form-item>
          
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="userForm.email" placeholder="请输入邮箱" />
          </el-form-item>
          
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="userForm.phone" placeholder="请输入手机号" />
          </el-form-item>
          
          <el-form-item label="状态">
            <el-radio-group v-model="userForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" v-permission="'user:add'" @click="handleSubmit">提交</el-button>
            <el-button @click="handleCancel">取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAdd',
  data() {
    return {
      userForm: {
        username: '',
        password: '',
        confirmPassword: '',
        email: '',
        phone: '',
        status: 1
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 20, message: '用户名长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于 6 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.userForm.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          // 模拟提交表单
          try {
            // 这里应该调用API提交表单数据
            // await createUser(this.userForm)
            
            this.$message.success('添加用户成功')
            this.$router.push('/users/list')
          } catch (error) {
            this.$message.error('添加用户失败：' + (error.message || '未知错误'))
          }
        }
      })
    },
    handleCancel() {
      this.$router.push('/users/list')
    }
  }
}
</script>

<style scoped>
.user-add-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h3 {
  color: #303133;
  font-size: 18px;
}

.content-wrapper {
  margin-top: 20px;
}

.el-form {
  padding: 20px 0;
}

.el-form-item {
  margin-bottom: 25px;
}
</style>